import { IOptionsWithTypes } from "@eventr/common";
import { ColoursObj, Typography } from "@eventr/common-storybook";
import { Box, Stack } from "@mui/material";
import { useGlobalRouter } from "feat/globalRouter/useGlobalRouter";
import { DirectChatButton } from "home/components/DirectChatButton";
import { MemberProfilePic } from "home/team/components/MemberProfilePic";
import { routes } from "routing";
import { bs, useBoundStore } from "state/bound.store";
import { useShallow } from "zustand/react/shallow";
import { useUserFilter } from "../hooks/useUserFilter";
import { useObjectContext } from "../providers/objectProvider";
export interface IUsersListProps {
  userList: IOptionsWithTypes[];
  showChat?: boolean;
  subInfo?: React.ReactNode;
}

export const UsersList = ({ userList, showChat = true, subInfo }: IUsersListProps) => {
  const { past } = useObjectContext();
  const { filterUsers } = useUserFilter();
  const { pushPath } = useGlobalRouter();
  const { getCurrentUser } = useBoundStore(
    useShallow((s) => {
      return {
        getCurrentUser: s.getCurrentUser,
      };
    }),
  );

  const users = filterUsers(userList);
  const currentUser = getCurrentUser();

  return (
    <Stack spacing="8px" sx={{
      marginTop: "8px"
    }}>
      {users.map((user, rowId) => (
        <Stack
          key={rowId}
          direction="row"
          sx={{
            justifyContent: "space-between",
            alignItems: "center"
          }}>
          <Stack
            spacing="16px"
            direction="row"
            onClick={() => pushPath(routes.team.member.build({ userId: user.id }))}
            sx={{
              alignItems: "center"
            }}
          >
            <MemberProfilePic user={user} />
            <Box>
              <Typography
                id="userNames"
                variant="bodyRegular"
                color={past ? ColoursObj.shades.shade2 : ColoursObj.font.primary}
                sx={{
                  width: "calc(var(--app-width) * 0.56)",
                  overflow: "hidden",
                  textOverflow: "ellipsis"
                }}>
                {bs().getNameFormatted(user)}
              </Typography>
              {subInfo}
            </Box>
          </Stack>

          {user.id !== currentUser?.id && user.firstName && user.lastName && showChat && (
            <DirectChatButton user_id={currentUser?.id ?? -1} user_id2={user.id} fullWidth={false} past={past} />
          )}
        </Stack>
      ))}
    </Stack>
  );
};
